import { zodResolver } from '@hookform/resolvers/zod';
import { type FieldValues, useForm } from 'react-hook-form';

import type { TValidationForm } from '../interfaces/TValidatedForm';

export const useValidationForm = <T extends FieldValues>({
  schema,
  defaultValues,
  shouldUseNativeValidation = false,
}: TValidationForm<T>) => {
  const resolver = schema ? zodResolver(schema) : undefined;

  const form = useForm<T>({
    resolver,
    defaultValues,
    shouldUseNativeValidation,
  });

  return {
    ...form,
    validationErrors: form.formState.errors,
    registerInput: form.register,
  };
};
